import React, { useState } from 'react';
import { multiFactor, TotpMultiFactorGenerator } from 'firebase/auth';
import MFAEinrichten from './MFAEinrichten';
import './MFA.css';

export default function MFAEinstellungen({ nutzer }) {
  const [zeigEinrichten, setZeigEinrichten]     = useState(false);
  const [deaktiviereConfirm, setDeaktiviereConfirm] = useState(false);
  const [laden, setLaden]                        = useState(false);
  const [fehler, setFehler]                      = useState(null);

  const enrolledFactors = multiFactor(nutzer).enrolledFactors;
  const totpFaktor      = enrolledFactors.find(
    f => f.factorId === TotpMultiFactorGenerator.FACTOR_ID
  );
  const istAktiv = !!totpFaktor;

  const deaktivieren = async () => {
    setFehler(null);
    setLaden(true);
    try {
      await multiFactor(nutzer).unenroll(totpFaktor);
      setDeaktiviereConfirm(false);
    } catch (err) {
      if (err.code === 'auth/requires-recent-login') {
        setFehler('Bitte melde dich erneut an, um 2FA zu deaktivieren.');
      } else {
        setFehler('Fehler beim Deaktivieren. Bitte versuche es erneut.');
      }
    } finally {
      setLaden(false);
    }
  };

  if (zeigEinrichten) {
    return (
      <MFAEinrichten
        nutzer={nutzer}
        onFertig={() => setZeigEinrichten(false)}
        onAbbrechen={() => setZeigEinrichten(false)}
      />
    );
  }

  return (
    <div className="mfa-settings-card">
      <div className="mfa-settings-header">
        <div className="mfa-settings-icon-wrap">
          <span className="mfa-settings-icon">{istAktiv ? '🛡️' : '🔓'}</span>
        </div>
        <div className="mfa-settings-info">
          <h3>Zwei-Faktor-Authentifizierung</h3>
          <p>
            {istAktiv
              ? 'Dein Konto ist durch 2FA geschützt. Bei jeder Anmeldung wird ein Code abgefragt.'
              : 'Erhöhe die Sicherheit deines Kontos mit einer Authenticator-App.'}
          </p>
        </div>
        <div className={`mfa-status-badge ${istAktiv ? 'aktiv' : 'inaktiv'}`}>
          {istAktiv ? 'Aktiv' : 'Inaktiv'}
        </div>
      </div>

      {fehler && <div className="mfa-error">{fehler}</div>}

      {istAktiv ? (
        deaktiviereConfirm ? (
          <div className="mfa-deactivate-confirm">
            <p>Bist du sicher? Dein Konto wird danach weniger geschützt sein.</p>
            <div className="mfa-btn-row">
              <button className="mfa-btn-danger" onClick={deaktivieren} disabled={laden}>
                {laden ? <span className="auth-spinner" /> : 'Ja, 2FA deaktivieren'}
              </button>
              <button className="mfa-btn-ghost" onClick={() => setDeaktiviereConfirm(false)}>
                Abbrechen
              </button>
            </div>
          </div>
        ) : (
          <button
            className="mfa-btn-ghost mfa-deactivate-btn"
            onClick={() => setDeaktiviereConfirm(true)}
          >
            2FA deaktivieren
          </button>
        )
      ) : (
        <button className="mfa-btn-primary" onClick={() => setZeigEinrichten(true)}>
          2FA einrichten
        </button>
      )}
    </div>
  );
}
